<template>
  <div class="modal fade" id="editCarrierModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="editCarrierModal" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ carrier ? 'Sélectionner un point relais' : 'Modes de livraison disponibles' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <!-- Transporteurs avec id_carrier_mode_wms = 1 -->
          <div v-if="!carrier && carriersDomicile.length" class="row g-3 align-items-center">
            <table class="table table-striped text-start align-middle">
              <thead>
                <tr>
                  <th>Livraison à domicile</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(carrier, index) in carriersDomicile" :key="index">
                  <td>{{ carrier.name }}</td>
                  <td class="text-end">
                    <button type="button" class="btn btn-success btn-sm" @click="updateCarrier(carrier)" data-bs-dismiss="modal">Séléctionner</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Transporteurs avec id_carrier_mode_wms = 2 -->
          <div v-if="!carrier && carriersPickup.length" class="row g-3 align-items-center">
            <table class="table table-striped text-start align-middle">
              <thead>
                <tr>
                  <th>Livraison en point relais</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(carrier, index) in carriersPickup" :key="index">
                  <td>{{ carrier.name }}</td>
                  <td class="text-end">
                    <button type="button" class="btn btn-primary btn-sm" @click="updateCarrier(carrier)">Choisir un point relais</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="carrier" class="row g-3 h-100 align-items-center">
            
            <!-- Template Click & Collect -->
            <div v-if="carrier && carrier.id_carrier_wms == 16" class="row g-3">
              <div v-for="(store, index) in clickAndCollect" :key="index" class="col-md-4">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">{{ store.lastname }}</h5>
                    <p class="card-text">
                      {{ store.street }}<br>
                      {{ store.postcode }} {{ store.city }}
                    </p>
                    <button type="button" class="btn btn-success btn-sm" data-bs-dismiss="modal" @click="selectStore(store)">Sélectionner cette boutique</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template Retrait BELISOFT -->
            <div v-if="carrier && carrier.id_carrier_wms == 17" class="row g-3">
              <div class="col-md-4">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">Retrait Rillieux</h5>
                    <p class="card-text">
                      1767 avenue de l'hippodrome<br>
                      69140 Rillieux-la-Pape
                    </p>
                    <button type="button" class="btn btn-success btn-sm" data-bs-dismiss="modal" @click="selectStore({store: id_pickup = 'BEL1767'})">Sélectionner</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template Points Relais -->
            <div v-else-if="carrier.id_carrier_mode_wms == 2" class="col-12 h-100">
              <input type="hidden" id="relayPoint">
              <div id="carrier-widget-container">
                <loader />
              </div>
            </div>
          </div>

        </div>

        <div v-if="carrier && carrier.id_carrier_mode_wms == 2" class="modal-footer">
          <button type="button" class="btn btn-primary" @click="clearCarrier">Choisir un autre transporteur</button>
          <button type="button" class="btn btn-success" @click="updateRelayPoint" :disabled="!confirm" data-bs-dismiss="modal">
            {{ confirm ? 'Appliquer ce point relais' : 'Veuillez séléctionner un point relais' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import backend from '@/services/backendService';

export default {
  props: {
    carriers: {
      type: Array, 
      required: true,
      default: () => ([]),
    },
  },
  data() {
    return {
      carrier: null,
      id_relay: null,
      confirm: false,
      token: '',
    };
  },
  computed: {
    ...mapGetters('order', [
      'order'
    ]),
    carriersDomicile() {
      return this.carriers.filter(carrier => (carrier.id_carrier_mode_wms == 1 || carrier.id_carrier_mode_wms == 3) && carrier.active == 1);
    },
    carriersPickup() {
      return this.carriers.filter(carrier => carrier.id_carrier_mode_wms == 2 && carrier.active == 1);
    },
    clickAndCollect() {
      return this.order.stores.filter(store => (store.id_address < 6));
    },
  },
  methods: {
    ...mapActions('order', [
      'updateOrderShippingMethod',
    ]),
    ...mapActions('preparation', [
      'updatePreparationCarrier',
      'updatePreparationRelayPoint',
    ]),
    displayConfirmButton() {
      this.confirm = true;
    },
    clearCarrier() {
      this.carrier = null;
      this.$nextTick(() => {
        const container = document.getElementById('carrier-widget-container');
        if (container) {
          container.innerHTML = '';
        }
      });
    },
    updateCarrier(carrier) {
      this.carrier = carrier;
      if (carrier.id_carrier_mode_wms == 2) {
        if (carrier.id_carrier_wms == 5) {
          this.loadColissimoWidget();
        }
        if (carrier.id_carrier_wms == 14) {
          this.initializeMondialRelayWidget();
        }
      } else {
        this.updateOrderShippingMethod(this.carrier);
        this.updatePreparationCarrier(this.carrier);
      }
    },
    selectStore(store) {
      this.id_relay = store.id_pickup;
      this.updateRelayPoint();
    },
    selectColissimoRelay(data) {
      this.id_relay = data.identifiant;
      this.confirm = true;
    },
    updateRelayPoint() {
      this.updateOrderShippingMethod(this.carrier);
      this.updatePreparationCarrier(this.carrier);
      this.updatePreparationRelayPoint(this.id_relay);
    },
    async loadColissimoWidget() {
      try {
        const response = await backend.get('/config/colissimo-token');
        this.token = response.token;
        if (this.token) {
          this.initializeColissimoWidget();
        } else {
          console.error('Échec de la récupération du token Colissimo.');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération du token Colissimo:', error);
      }
    },
    initializeColissimoWidget() {
      window.selectColissimoRelay = this.selectColissimoRelay;
      window.$('#carrier-widget-container').frameColissimoClose();
      window.$('#carrier-widget-container').frameColissimoOpen({
        "URLColissimo": 'https://ws.colissimo.fr',
        "callBackFrame": 'selectColissimoRelay',
        "ceCountryList": 'FR,BE,LU,ES,IT',
        "ceCountry": this.order.shipping_address.country_id,
        "ceAddress": this.order.shipping_address.street[0],
        "ceZipCode": this.order.shipping_address.postcode,
        "ceTown": this.order.shipping_address.city,
        "token": this.token
      });
    },
    initializeMondialRelayWidget() {
      window.$(document).ready(() => {
        window.$("#carrier-widget-container").MR_ParcelShopPicker({
          OnParcelShopSelected: (data) => {
            this.id_relay = data.ID;
            this.confirm = true;
          },
          Target: "#relayPoint",
          Brand: "F1BELISO",
          Theme: "mondialrelay",
          NbResults: 15,
          Responsive: true,
          MapScrollWheel: true,
          EnableGeolocalisatedSearch: false,
          Country: this.order.shipping_address.country_id,
          PostCode: this.order.shipping_address.postcode,
          City: this.order.shipping_address.city,
        });
      });  
    },
    loadExternalScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    async loadScripts() {
      try {
        await this.loadExternalScript("https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.js");
        await this.loadExternalScript("https://api.mapbox.com/mapbox-gl-js/v2.6.1/mapbox-gl.js");
        await this.loadExternalScript("https://unpkg.com/leaflet/dist/leaflet.js");
        await this.loadExternalScript("https://ws.colissimo.fr/widget-colissimo/js/jquery.plugin.colissimo.min.js");
        await this.loadExternalScript("https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js");
      } catch (error) {
        console.error('Erreur lors du chargement des scripts externes:', error);
      }
    }
  },
  mounted() {
    this.loadScripts();
  },
};
</script>


<style scoped>
@import "https://api.mapbox.com/mapbox-gl-js/v2.6.1/mapbox-gl.css";
@import "https://unpkg.com/leaflet/dist/leaflet.css";

.widget_colissimo_contenu {
  width: 100% !important;
}
</style>
